import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2a13caf8&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=2a13caf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13caf8",
  null
  
)

export default component.exports